import { ErpDataTableV2 } from '@/components/custom/erp';

import React from 'react';
import { EditPrintTemplateDialog } from './components/edit-print-template';
import { useActionHandlers, useDialogState, useTableData } from './hooks';
import InitialSearchDialog from './components/InitialSearchDialog';
import ActionBar from './components/ActionBar';

export default function PurchaseOrderStatusReportPage() {
  const {
    initialSearchDialogOpen,
    editPrintTemplateDialogOpen,
    showTable,
    searchParams,

    handleInitialSearchClose,
    handleInitialSearch,
    handleSearchClick,
    handleEditPrintTemplateClick,
    handleClosePrintTemplateDialog,
    handleSavePrintTemplate
  } = useDialogState();

  const { tables, handleRowClick, isLoading, error, refreshData } = useTableData(searchParams);

  const { handleRefreshClick, handleFixedColumnsClick, handleExportDataClick } = useActionHandlers(refreshData);

  return (
    <div className='flex h-full min-h-[calc(100vh-64px)] w-full min-w-0 flex-col overflow-hidden'>
      <InitialSearchDialog
        open={initialSearchDialogOpen}
        onClose={handleInitialSearchClose}
        onSearch={handleInitialSearch}
      />

      <EditPrintTemplateDialog
        open={editPrintTemplateDialogOpen}
        onClose={handleClosePrintTemplateDialog}
        onSave={handleSavePrintTemplate}
      />

      {showTable && (
        <>
          <ActionBar
            onSearchClick={handleSearchClick}
            onRefreshClick={handleRefreshClick}
            onFixedColumnsClick={handleFixedColumnsClick}
            onExportDataClick={handleExportDataClick}
            onEditPrintTemplateClick={handleEditPrintTemplateClick}
            className='border-b border-gray-200'
            searchParams={searchParams}
          />

          <div className='min-h-0 min-w-0 flex-1 overflow-hidden'>
            <ErpDataTableV2 tables={tables} onRowClick={handleRowClick} loading={isLoading} />
          </div>
        </>
      )}
    </div>
  );
}
